import { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import RenderMedia from "./RenderMedia";
import PostActions from "../../components/LikeCommentActions";
import { ExternalLink, Link } from "lucide-react";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const PostDetail = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);
  const token = localStorage.getItem("access_token");
  const navigate = useNavigate();
  const [followStatus, setFollowStatus] = useState({});
  const passedPostRaw = localStorage.getItem('activePost');
  const passedPost = passedPostRaw ? JSON.parse(passedPostRaw) : null;
  const [pubExpanded, setPubExpanded] = useState(false);
  const [isLiked, setIsLiked] = useState(post?.is_liked || false);
  const [totalLikes, setTotalLikes] = useState(post?.total_likes || 0);
  // console.log("passed data" , post);
  const fetchCurrentUser = async () => {
    if (!token) return;

    try {
      const res = await axios.get(`${BASE_URL}/user/profile/create-profile/`, {
        headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY, },
      });

      if (res.data) {
        // console.log("the data is:",res?.data)
        setCurrentUser(res.data?.data);
        console.log(setCurrentUser);
        setCurrentUserId(res.data.data.id);
      }
    } catch (err) {
      console.error("Failed to fetch current user", err);
    }
  };
  console.log("hdfkjdjhg")
  useEffect(() => {
    if (passedPost) {
      const normalized = {
        ...passedPost,
        user_profile: passedPost.user,
        type: passedPost.type || passedPost.post_type || "post",
        total_likes: passedPost.like_count ?? 0,
        total_comments: passedPost.comment_count ?? 0,
        latest_comment: passedPost.comments?.[0] || null,
        reads: passedPost.reads ?? 0,
      };

      setPost(normalized);
      fetchCurrentUser();
      return;
    }
    if (!id || !type) {
      setError("Invalid post link. Please try again.");
      return;
    }

    const fetchPost = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/user/publication/home/?id=${id}&type=${type}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_X_API_KEY
            },
          }
        );

        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(
            `Server responded with: ${res.status} - ${errorText}`
          );
        }

        const data = await res.json();

        const normalized = {
          ...data,
          user_profile: data?.user_profile,
          type: data.type || data.post_type || "post",
          total_likes: data.like_count ?? 0,
          total_comments: data.comment_count ?? 0,
          latest_comment: data.comments?.[0] || null,
          reads: data.reads ?? 0,
        };

        console.log("Normalized API Data:", normalized);
        setPost(normalized);
      } catch (err) {
        console.error("Error loading post:", err);
        setError("Failed to load post. Please try again later.");
      }
    };

    fetchPost();
    fetchCurrentUser();
  }, [id, type, token, passedPost]);

  useEffect(() => {
    const fetchFollowings = async () => {
      if (!token) return;
      try {
        const res = await axios.get(
          `${BASE_URL}/user/follow-unfollow/follow/`,
          {
            headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
          }
        );
        const followedItems = res.data?.results || [];
        const statusMap = {};
        followedItems.forEach((item) => {
          const userProfile = item.follow_user_profile;
          if (userProfile?.id) statusMap[String(userProfile.id)] = true;
        });
        setFollowStatus(statusMap);
      } catch (err) {
        console.error("Failed to fetch followings", err);
      }
    };
    if (currentUserId) fetchFollowings();
  }, [token, currentUserId]);

  // const handleFollowToggle = async (userId) => {
  //   const stringUserId = String(userId);
  //   const isFollowing = followStatus[stringUserId];
  //   try {
  //     if (isFollowing) {
  //       const res = await axios.delete(
  //         `${BASE_URL}/user/follow-unfollow/follow/`,
  //         {
  //           headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
  //           data: { id: userId },
  //         }
  //       );
  //       if (
  //         res.status === 204 ||
  //         res.data?.message === "Successfully unfollowed."
  //       ) {
  //         setFollowStatus((prev) => ({ ...prev, [stringUserId]: false }));
  //         toast.success("Unfollowed successfully");
  //       }
  //     } else {
  //       const res = await axios.post(
  //         `${BASE_URL}/user/follow-unfollow/follow/`,
  //         { id: userId },
  //         {
  //           headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
  //         }
  //       );
  //       if (res.data?.message === "Successfully followed") {
  //         setFollowStatus((prev) => ({ ...prev, [stringUserId]: true }));
  //         toast.success("Followed successfully");
  //       }
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Failed to update follow status");
  //   }
  // };

  if (error) return <div className="p-5 text-red-500">{error}</div>;
  if (!post) return <div className="p-5 flex justify-center items-center"><ClipLoader color="#3659d7ff" size={50} /></div>;
  const handleClose = () => {
    localStorage.removeItem('activePost');
    navigate('/home');
  };

  return (
    <>
      <div className="bg-[#F9F7F4] flex items-center justify-center overflow-hidden">
        <div className="w-full h-full sm:w-screen sm:h-screen bg-[#F9F7F4] relative flex flex-col sm:flex">
          <button
            onClick={handleClose}
            className="absolute top-[1px] left-4 w-10 h-10 flex items-center justify-center bg-[#e8f0f7] text-[#0f6abf] rounded-full  z-10"
          >
            ✕
          </button>
          <div className="flex flex-col sm:flex-row w-full h-full">
            <div className="w-full h-[60vh] sm:h-full sm:w-9/12 p-2 overflow-hidden flex items-center justify-center bg-[#F9F7F4]">
              <div className="w-full mt-12 md:mt-0 md:w-[90%] h-full   rounded-lg overflow-hidden">
                {
                  post && <RenderMedia post={post} type={type} />
                }

              </div>
            </div>
            <div className="relative w-full sm:w-3/12 h-[40vh] sm:h-full flex flex-col bg-white overflow-hidden">
              <div className="flex-1 overflow-y-auto p-3 sm:pt-6 sm:px-4">
                {/* User Info - Mobile optimized */}
                <div className="flex items-center gap-3">
                  <div className="relative">
                    <img
                      src={post?.user_profile?.profile_picture}
                      alt="User"
                      className="w-10 h-10 sm:w-12 sm:h-12 cursor-pointer rounded-xl object-cover border-2 border-white shadow-sm"
                     onClick={()=>navigate(`${currentUserId === post?.userId ? "/profile-view" : `/user-profile/${post?.user_profile?.id}`}`)}
                    />
                    <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
                  </div>
                  <div className="flex flex-col">
                    <span className="font-semibold text-gray-900 text-sm sm:text-base">
                      {post?.user_profile?.name}
                    </span>
                  </div>
                </div>
                {
                  post?.description ?
                    <div className="mt-3 sm:mt-4 text-base sm:text-lg  text-gray-900 mb-2 break-words">
                      {pubExpanded || (post?.description?.length || 0) <= 120
                        ? post?.description
                        : post?.description.slice(0, 120) + "..."}

                      {(post?.description?.length || 0) > 120 && (
                        <span
                          onClick={() => setPubExpanded(!pubExpanded)}
                          className="text-blue-600 cursor-pointer ml-1 font-medium"
                        >
                          {pubExpanded ? " Read less" : " Read more"}
                        </span>
                      )}
                    </div>
                    :
                    <div className="mt-3 sm:mt-4 text-base sm:text-lg  text-gray-900 mb-2 break-words">
                      {pubExpanded || (post?.abstract?.length || 0) <= 120
                        ? post?.abstract
                        : post?.abstract.slice(0, 120) + "..."}

                      {(post?.abstract?.length || 0) > 120 && (
                        <span
                          onClick={() => setPubExpanded(!pubExpanded)}
                          className="text-blue-600 cursor-pointer ml-1 font-medium"
                        >
                          {pubExpanded ? " Read less" : " Read more"}
                        </span>
                      )}
                    </div>
                }
                {post?.reference && (
                  <div className="my-4 p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
                    <div className="flex items-center gap-2 mb-3">
                      <ExternalLink size={18} className="text-blue-500" />
                      <h3 className="text-lg font-semibold text-gray-800">Reference Post</h3>
                    </div>
                    <a
                      href={post?.reference}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-200 group"
                    >
                      <Link size={16} className="text-gray-400 group-hover:text-blue-500" />
                      <span className="text-blue-600 hover:text-blue-700 font-medium break-all">
                        {post?.reference}
                      </span>
                    </a>
                  </div>
                )}

                {currentUserId && (
                  <div className="border-t pt-4">
                    <PostActions
                      postId={post?.id}
                      type={type}
                      is_Liked={isLiked}
                      likeCount={totalLikes}
                      commentCount={post?.total_comments}
                      currentUser={currentUserId}
                      onLikeChange={(postId, liked) => {
                        setIsLiked(liked);
                        setTotalLikes(prev => liked ? prev + 1 : prev - 1);
                      }}
                      isOpen={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
export default PostDetail
